import React from 'react';
import { FormControl, FormGroup } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import Link from '../../components/Link';

import showToaster from '../../helpers/toasterMessages/showToaster';
import { salesUser } from '../../helpers/DemoRestriction/demo';
import { getConfigData } from '../../helpers/getConfigData';
import messages from '../../locale/jsonMessages';
//Images
import { AddPlusSvg, ExportIcon } from '../Common/Assets/SvgIconComponent/CommonSvgIcon';
import cs from '../../components/commonStyle.css';
import s from '../../styles/commonTable.css';

class CommonTable extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isDemoRestrict: 'false',
            internalSearch: ''

        }
    }

    async componentDidMount() {
        const { getSpecificConfig } = this.props;
        const settingData = await getConfigData({ name: ['isDemoRestricted'] });
        this.setState({ isDemoRestrict: settingData?.isDemoRestricted });

        // Fix Safari RTL scroll position - set to rightmost edge (max scroll) on page load
        this.resetSafariRTLScrollPosition();
    }

    componentDidUpdate(prevProps) {
        // Reset scroll position when table data changes in RTL mode
        const { tbody } = this.props;
        const prevTbody = prevProps.tbody;
        if (tbody !== prevTbody) {
            this.resetSafariRTLScrollPosition();
        }
    }

    resetSafariRTLScrollPosition = () => {
        // Detect RTL mode reliably - check multiple sources
        const isRTL = document.body.classList.contains('rtl') ||
            document.documentElement.dir === 'rtl' ||
            document.documentElement.getAttribute('lang') === 'ar' ||
            (this.props.intl && this.props.intl.locale === 'ar');

        if (isRTL) {
            // Check if Safari browser
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

            if (isSafari) {
                // Function to set scroll to rightmost position
                const setScrollToRight = () => {
                    const tableWrapper = this.tableWrapperRef;
                    if (tableWrapper) {
                        // In RTL mode with direction: ltr on scroll container,
                        // Safari needs scrollLeft set to maximum to show rightmost content
                        // Calculate maximum scroll position
                        const scrollWidth = tableWrapper.scrollWidth;
                        const clientWidth = tableWrapper.clientWidth;
                        const maxScrollLeft = scrollWidth - clientWidth;

                        // Set scroll position to maximum (rightmost edge) for RTL
                        // This makes Safari behave like Chrome/Firefox
                        if (maxScrollLeft > 0) {
                            tableWrapper.scrollLeft = maxScrollLeft;
                        } else {
                            // If no scroll needed, ensure we're at start (0)
                            tableWrapper.scrollLeft = 0;
                        }
                    }
                };

                // Use setTimeout to ensure DOM is ready and table is fully rendered
                setTimeout(setScrollToRight, 0);

                // Also reset after a short delay to handle async rendering
                setTimeout(setScrollToRight, 100);

                // Additional check after table content is fully loaded
                setTimeout(setScrollToRight, 300);
            }
        } else {
            // For LTR mode, ensure scroll starts at 0 (leftmost)
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (isSafari) {
                setTimeout(() => {
                    const tableWrapper = this.tableWrapperRef;
                    if (tableWrapper) {
                        tableWrapper.scrollLeft = 0;
                    }
                }, 0);
            }
        }
    }

    restrictExport = () => {
        showToaster({ messageId: 'disableDemo', toasterType: 'warning' })
    };

    render() {
        const { thead, tbody, title, onSearch, isSearch, isLink, isExport, exportLink, redirectionLabel, href, addAction, className, isHeadingHide, handleFilter, tableWrapperTitle, filterValue } = this.props;
        const { userTypeFilter, handleUserChange, listFilters, onChange, adminId, filterOption, isPromoCodeSection } = this.props;
        const { formatMessage } = this.props.intl;
        const { isDemoRestrict } = this.state;
        const theadData = thead();
        const tbodyData = tbody && tbody();

        return (
            <div>
                {!isHeadingHide && <h1 className={cx(!tableWrapperTitle && 'siteAdminHeading', tableWrapperTitle)}>{title}</h1>}
                {(isSearch || listFilters || userTypeFilter || filterOption || (isLink && href) || (isLink && addAction) || (tbodyData?.length > 0 && isExport)) &&
                    <div className={cx(cs.dFlexContainer, cs.mobileTableSearch,
                        { [cs.mobileTableOnlyLink]: ((!isSearch && !listFilters && !userTypeFilter) && (isLink || isExport)) })}>
                        {(isSearch || listFilters || userTypeFilter || filterOption) &&
                            <div className={cs.commonSearchInputFilterContainer}>
                                {isSearch &&
                                    <FormControl
                                        type="text"
                                        placeholder={formatMessage(messages.search)}
                                        onChange={(e) => onSearch(e)}
                                        className={cx('commonSearchIconInput', 'searchInputControlWidth')}
                                    />
                                }

                                {listFilters?.length > 0 &&
                                    <FormGroup controlId="formControlsSelect" bsClass='filterSelectContainer'>
                                        <FormControl onChange={(e) => onChange(Number(e.target.value))} componentClass="select" bsClass='commonSelectField'>
                                            {listFilters?.map((item, index) => <option key={index} value={item?.value}>{item?.label}</option>)}
                                        </FormControl>
                                    </FormGroup>
                                }

                                {userTypeFilter?.length > 0 &&
                                    <FormGroup controlId="formControlsSelect" bsClass='filterSelectContainer'>
                                        <FormControl onChange={(e) => handleUserChange(e.target.value)} componentClass="select" bsClass='commonSelectField'>
                                            {userTypeFilter?.map((item, index) => <option key={index} value={item?.value}>{item?.label}</option>)}
                                        </FormControl>
                                    </FormGroup>
                                }

                                {filterOption?.length > 0 && (

                                    <FormGroup controlId="formControlsSelect" bsClass='filterSelectContainer'>
                                        <FormControl
                                            onChange={handleFilter}
                                            componentClass="select"
                                            bsClass='commonSelectField'
                                            value={filterValue ?? ''}
                                        >
                                            {filterOption?.map((item, index) => (
                                                <option key={index} value={item?.value}>
                                                    {item?.label}
                                                </option>
                                            ))}
                                        </FormControl>
                                    </FormGroup>
                                )}
                            </div>}

                        {
                            isLink && href && <div>
                                <Link to={href} className={cx(cs.dFlex, cs.commonLinkBorder, cs.noTextDecration,
                                    cs.commonContentText, cs.fontWeightMedium, cs.siteLinkColor, cs.textNoWrap)}>
                                    <AddPlusSvg />
                                    {redirectionLabel}
                                </Link> </div>
                        }

                        {
                            isLink && addAction && <div>
                                <Link noLink onClick={addAction} className={cx(cs.dFlex, cs.gap4, cs.commonLinkBorder, cs.noTextDecration,
                                    cs.commonContentText, cs.fontWeightMedium, cs.siteLinkColor, cs.textNoWrap)}>
                                    <AddPlusSvg />
                                    {redirectionLabel}
                                </Link> </div>
                        }

                        {
                            tbodyData?.length > 0 && isExport && <div>
                                {isDemoRestrict == 'true' && salesUser.indexOf(adminId) < 0 ?
                                    <a href={'#'} className={cx(cs.dFlex, cs.commonLinkBorder, cs.noTextDecration, cs.commonContentText, cs.fontWeightMedium, cs.siteLinkColor,cs.gap4)}
                                        onClick={() => this.restrictExport()}>
                                        <FormattedMessage  {...messages.exportDataIntoCSV} />
                                        <ExportIcon/>
                                    </a> :
                                    <a href={exportLink} className={cx(cs.dFlex, cs.commonLinkBorder, cs.noTextDecration, cs.commonContentText, cs.fontWeightMedium, cs.siteLinkColor,cs.gap4)}>
                                        <FormattedMessage  {...messages.exportDataIntoCSV} />
                                        <ExportIcon/>
                                    </a>}</div>
                        }
                    </div>}
                <div className={cx('tableContainer', className, (!tbodyData || tbodyData?.length == 0) && "tableNoDataContainer")}>
                    <div className='tableWrapper' ref={(el) => { this.tableWrapperRef = el; }}>
                        <table className='tableBox'>
                            <thead>
                                <tr>
                                    {
                                        theadData?.map((item, index) => {
                                            if (item) {
                                                return (
                                                    <th scope="col" key={index}>
                                                        {item.data}
                                                    </th>
                                                );
                                            }
                                            return null;
                                        })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    tbodyData?.length > 0 &&
                                    tbodyData.map((item) => (
                                        item?.data?.length > 0 ? (
                                            <tr key={item.id}>
                                                {item.data.map((value, index) => (
                                                    value ? (
                                                        <td
                                                            key={index}
                                                            data-label={theadData?.[index]?.data}
                                                        >
                                                            {value?.data}
                                                        </td>
                                                    ) : null
                                                ))}
                                            </tr>
                                        ) : null
                                    ))
                                }
                                {
                                    (!tbodyData || tbodyData?.length == 0) && <tr>
                                        <td colSpan={theadData?.length} className={'noRecordsText'}>
                                            {isPromoCodeSection ? <FormattedMessage  {...messages.noRecordsFoundLabel} /> : <FormattedMessage  {...messages.noRecordFound} />}
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

const mapState = (state) => ({
    adminUserModal: state?.account?.privileges?.id
});

const mapDispatch = {};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(CommonTable)));
